// Point d'entrée du moteur, assemblé par esbuild dans assets/app.bundle.js (voir Makefile).
// Ordre : le cœur (src/core/, données, domaines via compat/globals.js) pose ses fonctions sur window ; le code
// historique suit ; l'interface refaite (src/ui/) vient en dernier et remplace les rendus qu'elle a repris.
import './compat/globals.js';
import './domain/qcm/correcteurLocal.js';   // correction locale de l'active recall : pose window.corrigerRecallLocal
import './domain/qcm/bilanSoir.js';        // bilan du soir : pose window.itemsDuJour et window.avancementSoir
import './legacy/app.js';
import './legacy/qcm.js';
import './legacy/lca.js';
import './ui/theme.js';
import './ui/components/toast.js';
import './ui/components/lecteur.js';
import './ui/components/dialog.js';
import './ui/components/menu.js';
import './ui/shell.js';
import './ui/components/bandeaux.js';
import './ui/components/taskRow.js';
import './ui/pages/aujourdhui.js';
import './ui/pages/calendrier.js';
import './ui/pages/catalogue.js';
import './ui/pages/stats.js';
import './ui/pages/accueil.js';
import './ui/pages/connexion.js';
import './ui/pages/lca.js';
import './ui/pages/compte.js';
import './ui/pages/abonnement.js';
import './ui/pages/publiques.js';
import './ui/pages/methode.js';
import './ui/pages/gestion.js';
import './ui/pages/qcm.js';
import './ui/modals/autoplan.js';
import './ui/modals/planning.js';
import './ui/modals/podcast.js';
import './ui/modals/lots.js';

// Amorçage en dernier : tout le bundle a été évalué, donc tous les noms attendus par window.initApp
// (rendus de src/ui/, registre window.actions) sont posés. Si un import ci-dessus lève, on n'amorce pas
// du tout plutôt que d'amorcer à moitié.
document.addEventListener('DOMContentLoaded', window.initApp);
